module.exports = __webpack_public_path__ + "67fa42b95000a9432976cf62900d4f70.svg";